import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { DynamicFormService } from "core/dynamic-form";

import { Subject } from "rxjs";
import { DocumentInfoFormService } from "./document-info-form.service";
import { DocumentInfoModel } from "./types/document-info-model";


@Component({
  selector: 'ss-document-info-form',
  templateUrl: './document-info-form.component.html',
  styleUrls: ['./document-info-form.component.css'],
  providers: [
    DynamicFormService,
    DocumentInfoFormService
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentInfoFormComponent implements OnInit {

  @Output() submit = new EventEmitter<DocumentInfoModel>()

  private readonly _destroy = new Subject<void>();

  readonly mainFormGroupSubject = this._documentInfoFormService.mainFormGroupSubject;

  constructor(
    private readonly _documentInfoFormService: DocumentInfoFormService,
  ) {

  }

  ngOnInit(): void {

  }

  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();
  }
}
